module.exports = __webpack_public_path__ + "static/toppings-centered-69b2eb5b4e4e872a7297d64fc1dbefc5.png";